
import { RechargeType } from './recharge.type';
//add recharge section


export const setShowRecargeSection = (data) => ({
    type: RechargeType.setShowRecargeSection,
    payload: data
  
  });
  
  export const setCurrentOpertaor = (data) => ({
    type: RechargeType.setCurrentOpertaor,
    payload: data
  
  });
  export const setCurrenntCircle = (data) => ({
    type: RechargeType.setCurrenntCircle,
    payload: data
  
  });
  export const setRechrgeMobile = (data) => ({
    type: RechargeType.setRechrgeMobile,
    payload: data
  
  });
  export const selectedRechargableAmnt = (data) => ({
    type: RechargeType.selectedRechargableAmnt,
    payload: data
  
  });
  
  export const selectedRechargableAmnt1 = (data) => ({
    type: RechargeType.selectedRechargableAmnt1,
    payload: data
  
  });
  
  export const setRechargeType = (data) => ({
    type: RechargeType.setRechargeType,
    payload: data
  
  });
  
  //dth customerId
  export const setDTHCustomerId = (data) => ({
    type: RechargeType.setDTHCustomerId,
    payload: data
  
  });
  
  
  //recharge ranfer
  export const setMoneyTransferTotalAmount1 = (data) => ({
    type: RechargeType.setMoneyTransferTotalAmount1,
    payload: data
    
  }); 
  export const setMoneyTransferSurChargeAmount1 = (data) => ({
    type: RechargeType.setMoneyTransferSurChargeAmount1,
    payload: data
    
  });
  
  export const setOrderId1 = (data) => ({
    type: RechargeType.setOrderId1,
    payload: data
    
  });
  
  export const setAmount1 = (data) => ({
    type: RechargeType.setAmount1,
    payload: data
    
  }); 
  
  export const setCreteOrderReq1 = (data) => ({
    type: RechargeType.setCreteOrderReq1,
    payload: data
    
  });
  
  export const setCreateOrderRes1 = (data) => ({
    type: RechargeType.setCreateOrderRes1,
    payload: data
    
  });
  
  //recharge details
  
  
  export const setBrowsePlans = (data) => ({
    type: RechargeType.setBrowsePlans,
    payload: data
    
  });
  
  
  export const setRechargeTxhHistory = (data) => ({
    type: RechargeType.setRechargeTxhHistory,
    payload: data
    
  });
  
  
  export const setTxnAmount1 = (data) => ({
    type: RechargeType.setTxnAmount1,
    payload: data
    
  });
  
  export const setTxnsurcharge1 = (data) => ({
    type: RechargeType.setTxnsurcharge1,
    payload: data
    
  });
  
  export const setTxntotalAmount1 = (data) => ({
    type: RechargeType.setTxntotalAmoun1,
    payload: data
    
  });
  
    
  export const setMoneyTransferProgress1 = (data) => ({
    type: RechargeType.setMoneyTransferProgress1,
    payload: data
    
  });
  
  export const setStatusEnqResponse1 = (data) => ({
    type: RechargeType.setStatusEnqResponse1,
    payload: data
    
  });
  
  export const setFilterStartDate = (data) => ({
    type: RechargeType.setFilterStartDate,
    payload: data
    
  });
  export const setFilterEndDate = (data) => ({
    type: RechargeType.setFilterEndDate,
    payload: data
    
  });
    export const resetRecharge ={
      type: RechargeType.RESET
    }